import { Component, OnDestroy, OnInit } from '@angular/core';
import { MaintScheduleJobsService } from '../../../core/service/maint-schedule-jobs.service';
import {
  ExportToExcel,
  ExportViewWeeklySchedule,
  Totals,
  ViewSchedules,
  ViewWeeklySchedule,
  FilterValueSelection,
} from '../../../core/interface/maint-schedule-jobs';
import { HttpResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import {
  weeklyScheduleMX,
  weeklyScheduleMXFilters,
} from '../../../core/constants/constants';
import { Router } from '@angular/router';
import { CommonService } from '../../../core/service/common.service';
import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';

@Component({
  standalone: false,
  selector: 'app-weekly-schedule-mx',
  templateUrl: './weekly-schedule-mx.component.html',
  styleUrl: './weekly-schedule-mx.component.less',
})
export class WeeklyScheduleMxComponent implements OnInit, OnDestroy {
  selectedOption = weeklyScheduleMX.craft;
  selectedFilter: string = weeklyScheduleMX.showall;
  weeklySchedule: ViewWeeklySchedule[] = [];
  weeklyScheduleRes: ViewWeeklySchedule[] = [];
  weeklyScheduleTotal: Totals | undefined;
  totalNScheduled: string = '0';
  totalHrsScheduled: number = 0;
  totalHrsCharged: number = 0;
  totalHrsPlanned: number = 0;
  totalNActual: string = '0';
  totalEqMp: number = 0;
  chargeSched: number = 0;
  schedplan: number = 0;
  routerData!: ExportToExcel;
  nMaxLen: number = 15;
  sFilterDisplay: string = '';
  scheduledJobsViewWeeklyScheduleMX!: Subscription;
  scheduledJobsGetmaximoLink!: Subscription;
  exportWeeklySchedule!: Subscription;
  showLoader = false;
  showExportLoader = false;
  weeklyScheduleMX = weeklyScheduleMX;
  weeklyScheduleMXFilters = weeklyScheduleMXFilters;
  wwDate!: Date;
  nextSevenDays: number[] = [];
  facId: string = '';
  crew!: string;
  totalSchedules: number = 0;
  filteredRecords: ViewWeeklySchedule[] = [];
  workTypes: FilterValueSelection[] = [];
  selectedWorkTypes: string[] = [];
  priority: FilterValueSelection[] = [];
  selectedPriority: string[] = [];
  taskType: FilterValueSelection[] = [];
  selectedTaskType: string[] = [];
  wonum: FilterValueSelection[] = [];
  selectedWonum: string[] = [];
  taskStatus: FilterValueSelection[] = [];
  selectedTaskStatus: string[] = [];
  division: FilterValueSelection[] = [];
  selectedDivision: string[] = [];
  unit: FilterValueSelection[] = [];
  selectedUnit: string[] = [];
  crews: FilterValueSelection[] = [];
  selectedCrew: string[] = [];
  basecraft: FilterValueSelection[] = [];
  selectedBasecraft: string[] = [];
  location: FilterValueSelection[] = [];
  selectedLocation: string[] = [];
  taskTitle: FilterValueSelection[] = [];
  selectedTaskTitle: string[] = [];

  disableNonMondays = (current: Date): boolean => {
    return current.getDay() !== 1;
  };

  constructor(
    private readonly maintScheduleJobsService: MaintScheduleJobsService,
    private readonly route: Router,
    private readonly commonService: CommonService
  ) {}

  ngOnInit(): void {
    // data from previous page
    this.routerData = history.state.data;

    //filter naming
    if (this.routerData) {
      this.wwDate = new Date(this.routerData.startDate);
      this.facId = this.routerData.facId;
      this.crew = this.routerData.crew;
      this.populateNextSevenDays();
      this.setFilterName();
      this.loadWeeklyScheduleMXData();
    }

    this.commonService.setNavigationDisabled(true);
  }

  populateNextSevenDays(): void {
    this.nextSevenDays = [];
    for (let i = 0; i < 7; i++) {
      const nextDay = new Date(this.wwDate);
      nextDay.setDate(this.wwDate.getDate() + i);
      this.nextSevenDays.push(nextDay.getDate());
    }
  }

  onDateChange(event: Date) {
    if (event) {
      // Set as local date for UI display
      this.wwDate = new Date(event.getFullYear(), event.getMonth(), event.getDate());
      const pad = (n: number) => String(n).padStart(2, '0');
      this.routerData.startDate = `${this.wwDate.getFullYear()}-${pad(this.wwDate.getMonth() + 1)}-${pad(this.wwDate.getDate())}T00:00:00`;
      this.populateNextSevenDays();
      this.loadWeeklyScheduleMXData();
    }
  }

  setFilterName() {
    const crew = this.routerData.crew;
    const div = this.routerData.divisions;
    const unit = this.routerData.units;

    if (crew) {
      if (crew?.length > this.nMaxLen) {
        this.sFilterDisplay += ' CREWs [Many...]';
      } else {
        this.sFilterDisplay += ` CREWs [${crew}]`;
      }
    }

    if (div) {
      if (div?.length > this.nMaxLen) {
        this.sFilterDisplay += ' AREAs [Many...]';
      } else {
        this.sFilterDisplay += ` AREAs [${div}]`;
      }
    }

    if (unit) {
      if (unit?.length > this.nMaxLen) {
        this.sFilterDisplay += ' UNITs [Many...]';
      } else {
        this.sFilterDisplay += ` UNITs [${unit}]`;
      }
    }
  }

  clearExistingData() {
    this.weeklySchedule = [];
    this.weeklyScheduleRes = [];
    this.weeklyScheduleTotal = undefined;
    this.filteredRecords = [];
    this.totalNScheduled = '0';
    this.totalHrsScheduled = 0;
    this.totalHrsCharged = 0;
    this.totalHrsPlanned = 0;
    this.totalNActual = '0';
    this.totalEqMp = 0;
    this.chargeSched = 0;
    this.schedplan = 0;
  }

  openCrewDetails() {
    this.route.navigateByUrl('/weekly-schedule-drill', {
      state: {
        data: { facId: this.facId, crew: this.crew, startDate: this.wwDate },
      },
    });
  }

  loadWeeklyScheduleMXData() {
    this.showLoader = true;
    this.clearExistingData();
    this.scheduledJobsViewWeeklyScheduleMX = this.maintScheduleJobsService
      .getScheduledJobsViewWeeklyScheduleMX(this.routerData)
      .subscribe({
        next: (viewSchedulesObj: ViewSchedules | null) => {
          if (
            viewSchedulesObj?.viewWeeklySchedules &&
            viewSchedulesObj.viewWeeklySchedules.length > 0
          ) {
            const schedules = viewSchedulesObj.viewWeeklySchedules;
            this.weeklySchedule =
              this.weeklyScheduleRes =
              this.filteredRecords =
                schedules;
            this.setFilterValues();
            this.calculateTotalCount();
            this.updateSchedulesCount();
          }
          if (viewSchedulesObj?.allTotals) {
            this.weeklyScheduleTotal = viewSchedulesObj.allTotals;
          }
        },
        error: (error) => {
          console.log(
            'Error occured in the loadWeeklyScheduleMXData method. Error: ',
            error
          );
        },
        complete: () => {
          this.showLoader = false;
        },
      });
  }

  // Sorting through craft and job
  onSortChange(value: string): void {
    if (value === 'craft') {
      this.setSortOrder('sort,craft,baseCraft,crew,wonum');
    } else if (value === 'job') {
      this.setSortOrder('woNbr,baseCraft,d1,d2,d3,d4,d5,d6,d7');
    }
  }

  setFilterValues(): void {
    this.weeklyScheduleRes.forEach((res: ViewWeeklySchedule) => {
      if (!this.priority.some((x) => x.name == res.taskPriority)) {
        this.priority.push({ name: res.taskPriority, selected: true });
        this.selectedPriority.push(res.taskPriority);
      }

      if (!this.wonum.some((x) => x.name == res.wonum)) {
        this.wonum.push({ name: res.wonum, selected: true });
        this.selectedWonum.push(res.wonum);
      }

      if (!this.taskType.some((x) => x.name == res.taskType)) {
        this.taskType.push({ name: res.taskType, selected: true });
        this.selectedTaskType.push(res.taskType);
      }

      if (!this.taskStatus.some((x) => x.name == res.taskStatus)) {
        this.taskStatus.push({ name: res.taskStatus, selected: true });
        this.selectedTaskStatus.push(res.taskStatus);
      }

      if (!this.division.some((x) => x.name == res.division)) {
        this.division.push({ name: res.division, selected: true });
        this.selectedDivision.push(res.division);
      }

      if (!this.unit.some((x) => x.name == res.unit)) {
        if (res.unit) {
          this.unit.push({ name: res.unit, selected: true });
          this.selectedUnit.push(res.unit);
        }
      }

      if (!this.crews.some((x) => x.name == res.crew)) {
        this.crews.push({ name: res.crew, selected: true });
        this.selectedCrew.push(res.crew);
      }

      if (!this.basecraft.some((x) => x.name == res.baseCraft)) {
        this.basecraft.push({ name: res.baseCraft, selected: true });
        this.selectedBasecraft.push(res.baseCraft);
      }

      if (!this.location.some((x) => x.name == res.location)) {
        this.location.push({ name: res.location, selected: true });
        this.selectedLocation.push(res.location);
      }

      if (!this.taskTitle.some((x) => x.name == res.taskTitle)) {
        this.taskTitle.push({ name: res.taskTitle, selected: true });
        this.selectedTaskTitle.push(res.taskTitle);
      }

      if (!this.workTypes.some((x) => x.name == res.workType)) {
        this.workTypes.push({ name: res.workType, selected: true });
        this.selectedWorkTypes.push(res.workType);
      }
    });
  }

  onFilterChange(filterValue: string, filterId: number) {
    const filterMap = {
      [weeklyScheduleMXFilters.priority]: this.priority,
      [weeklyScheduleMXFilters.wonum]: this.wonum,
      [weeklyScheduleMXFilters.taskType]: this.taskType,
      [weeklyScheduleMXFilters.taskStatus]: this.taskStatus,
      [weeklyScheduleMXFilters.division]: this.division,
      [weeklyScheduleMXFilters.unit]: this.unit,
      [weeklyScheduleMXFilters.crew]: this.crews,
      [weeklyScheduleMXFilters.basecraft]: this.basecraft,
      [weeklyScheduleMXFilters.location]: this.location,
      [weeklyScheduleMXFilters.taskTitle]: this.taskTitle,
      [weeklyScheduleMXFilters.workType]: this.workTypes,
    };

    const selectedFilterMap = {
      [weeklyScheduleMXFilters.priority]: this.selectedPriority,
      [weeklyScheduleMXFilters.wonum]: this.selectedWonum,
      [weeklyScheduleMXFilters.taskType]: this.selectedTaskType,
      [weeklyScheduleMXFilters.taskStatus]: this.selectedTaskStatus,
      [weeklyScheduleMXFilters.division]: this.selectedDivision,
      [weeklyScheduleMXFilters.unit]: this.selectedUnit,
      [weeklyScheduleMXFilters.crew]: this.selectedCrew,
      [weeklyScheduleMXFilters.basecraft]: this.selectedBasecraft,
      [weeklyScheduleMXFilters.location]: this.selectedLocation,
      [weeklyScheduleMXFilters.taskTitle]: this.selectedTaskTitle,
      [weeklyScheduleMXFilters.workType]: this.selectedWorkTypes,
    };

    if (filterMap[filterId]) {
      this.alter(filterValue, filterMap[filterId], selectedFilterMap[filterId]);
    }

    this.filterRowsBasedOnWorkType();
    this.calculateTotalCount();
    this.updateSchedulesCount();
  }

  alter(
    filterValue: string,
    filterArr: FilterValueSelection[],
    selectedFilterArr: string[]
  ) {
    const item = filterArr.find((item) => item.name === filterValue);
    if (item) {
      item.selected = !item.selected;
      if (item.selected) {
        selectedFilterArr.push(filterValue);
      } else {
        const index = selectedFilterArr.indexOf(filterValue);
        if (index > -1) {
          selectedFilterArr.splice(index, 1); // This modifies the original array
        }
      }
    }
  }

  filterRowsBasedOnWorkType() {
    this.weeklySchedule = this.filteredRecords.filter(
      (res: ViewWeeklySchedule) =>
        this.selectedPriority.includes(res.taskPriority) &&
        this.selectedWonum.includes(res.wonum) &&
        this.selectedTaskType.includes(res.taskType) &&
        this.selectedTaskStatus.includes(res.taskStatus) &&
        this.selectedDivision.includes(res.division) &&
        (res.unit ? this.selectedUnit.includes(res.unit) : false) &&
        this.selectedCrew.includes(res.crew) &&
        this.selectedBasecraft.includes(res.baseCraft) &&
        this.selectedLocation.includes(res.location) &&
        this.selectedTaskTitle.includes(res.taskTitle) &&
        this.selectedWorkTypes.includes(res.workType)
    );
  }

  private setSortOrder(orderBy: string): void {
    const order = orderBy.split(',');
    this.weeklySchedule.sort((a: ViewWeeklySchedule, b: ViewWeeklySchedule) => {
      for (let key of order) {
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
      }
      return 0;
    });
  }

  refresh() {
    this.selectedFilter = weeklyScheduleMX.showall;
    this.resetWorkTypes();
    this.populateNextSevenDays();
    this.loadWeeklyScheduleMXData();
  }

  shortenText(inputString: string | null | undefined): string {
    if (inputString == null) {
      return '';
    }
    if (inputString.length > 15) {
      const extracted = inputString.substring(0, 15);
      return extracted + '...';
    } else {
      return inputString;
    }
  }

  // format date for FBD
  formatDates(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${day}${month}${year}`;
  }

  setFilter(filterId: string) {
    this.selectedFilter = filterId;
    switch (filterId) {
      case 'open':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule: ViewWeeklySchedule) => schedule.openInd == 'Y'
        );
        break;
      case 'os':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule: ViewWeeklySchedule) => schedule.osInd == 'os'
        );
        break;
      case 'done':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule: ViewWeeklySchedule) => schedule.openInd == 'N'
        );
        break;
      case 'kit':
        this.weeklySchedule = this.weeklyScheduleRes.filter((schedule) =>
          /K/.test(schedule.sme)
        );
        break;
      case 'monthru':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule) =>
            schedule.d1 !== '' ||
            schedule.d2 !== '' ||
            schedule.d3 !== '' ||
            schedule.d4 !== ''
        );
        break;
      case 'showall':
        this.weeklySchedule = this.weeklyScheduleRes;
        break;
      case 'pm':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule: ViewWeeklySchedule) => /PM$/.test(schedule.workType)
        );
        break;
      case 'i':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule: ViewWeeklySchedule) => /^I/.test(schedule.baseCraft)
        );
        break;
      case 'e':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule: ViewWeeklySchedule) => /^E/.test(schedule.baseCraft)
        );
        break;
      case 'sf':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule: ViewWeeklySchedule) => schedule.safetyInd == 'S'
        );
        break;
      case 'm':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule: ViewWeeklySchedule) => /^M/.test(schedule.baseCraft)
        );
        break;
      case 'p':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule: ViewWeeklySchedule) => /^P/.test(schedule.baseCraft)
        );
        break;
      case 'bi':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule: ViewWeeklySchedule) => schedule.breakInd == 'bi'
        );
        break;
      case 'c':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule: ViewWeeklySchedule) => /^C/.test(schedule.baseCraft)
        );
        break;
      case 'oth':
        this.weeklySchedule = this.weeklyScheduleRes.filter(
          (schedule: ViewWeeklySchedule) => schedule.baseCraft == null
        );
        break;
      default:
        console.log('No such filter exists!');
    }
    this.filteredRecords = this.weeklySchedule;
    this.resetWorkTypes();
    this.calculateTotalCount();
    this.updateSchedulesCount();
  }

  resetWorkTypes() {
    this.priority = [];
    this.selectedPriority = [];
    this.wonum = [];
    this.selectedWonum = [];
    this.taskType = [];
    this.selectedTaskType = [];
    this.taskStatus = [];
    this.selectedTaskStatus = [];
    this.division = [];
    this.selectedDivision = [];
    this.unit = [];
    this.selectedUnit = [];
    this.crews = [];
    this.selectedCrew = [];
    this.basecraft = [];
    this.selectedBasecraft = [];
    this.location = [];
    this.selectedLocation = [];
    this.taskTitle = [];
    this.selectedTaskTitle = [];
    this.workTypes = [];
    this.selectedWorkTypes = [];
    this.setFilterValues();
  }

  setDayFilter(day: string) {
    this.selectedFilter = day;
    this.weeklySchedule = this.weeklyScheduleRes.filter(
      (schedule: ViewWeeklySchedule) => {
        if (day == 'mo') {
          return schedule.d1 !== null;
        } else if (day == 'tu') {
          return schedule.d2 !== null;
        } else if (day == 'we') {
          return schedule.d3 !== null;
        } else if (day == 'th') {
          return schedule.d4 !== null;
        } else if (day == 'fr') {
          return schedule.d5 !== null;
        } else if (day == 'sa') {
          return schedule.d6 !== null;
        } else if (day == 'su') {
          return schedule.d7 !== null;
        } else {
          return false;
        }
      }
    );
    this.filteredRecords = this.weeklySchedule;
    this.workTypes = [];
    this.resetWorkTypes();
    this.calculateTotalCount();
    this.updateSchedulesCount();
  }

  updateSchedulesCount() {
    this.totalSchedules = this.weeklySchedule.length;
  }

  private calculateTotalCount() {
    // Total & Scheduled
    const totalNScheduled = parseFloat(
      this.weeklySchedule
        .reduce((sum, schedule: ViewWeeklySchedule) => {
          return sum + schedule.craftRate * schedule.scheduledHours;
        }, 0)
        .toFixed(2)
    );
    this.totalNScheduled = totalNScheduled.toLocaleString('en-US');

    // Total Hrs Scheduled
    const totalHrsScheduled = this.weeklySchedule.reduce(
      (sum, schedule: ViewWeeklySchedule) => {
        return sum + schedule.scheduledHours;
      },
      0
    );
    this.totalHrsScheduled = parseFloat(totalHrsScheduled.toFixed(2));

    // Total Hrs Charged
    const totalHrsCharged = this.weeklySchedule.reduce(
      (sum, schedule: ViewWeeklySchedule) => {
        return sum + schedule.totalHours;
      },
      0
    );
    this.totalHrsCharged = parseFloat(totalHrsCharged.toFixed(2));

    // Total Hrs Planned
    const totalHrsPlanned = this.weeklySchedule.reduce(
      (sum, schedule: ViewWeeklySchedule) => {
        return sum + schedule.hoursActual;
      },
      0
    );
    this.totalHrsPlanned = parseFloat(totalHrsPlanned.toFixed(2));

    // Total and Actual
    const totalNActual = parseFloat(
      this.weeklySchedule
        .reduce((sum, schedule: ViewWeeklySchedule) => {
          return sum + schedule.craftRate * schedule.totalHours;
        }, 0)
        .toFixed(2)
    );
    this.totalNActual = totalNActual.toLocaleString('en-US');

    // Total EQ MP
    const totalEqMp = this.totalHrsScheduled / 40;
    this.totalEqMp = parseFloat(totalEqMp.toFixed(2));

    // Charge/Sched
    let chargeSched =
      this.totalHrsCharged == 0 && this.totalHrsScheduled == 0
        ? 0
        : this.totalHrsCharged / this.totalHrsScheduled;
    this.chargeSched = parseFloat(chargeSched.toFixed(2));

    // Sched/Plan
    let schedplan =
      this.totalHrsScheduled == 0 && this.totalHrsPlanned == 0
        ? 0
        : this.totalHrsScheduled / this.totalHrsPlanned;
    this.schedplan = parseInt((schedplan * 100).toString());
  }

  generateLinkUsingWonum(wonum: string) {
    this.scheduledJobsGetmaximoLink = this.maintScheduleJobsService
      .getScheduledJobsGetmaximoLink(wonum, this.facId)
      .subscribe({
        next: (data: HttpResponse<string>) => {
          const url = data as unknown as string;
          if (url?.includes('http')) {
            window.open(url, '_blank');
          }
        },
        error: (error) => {
          console.log(
            'Error occured in generateLinkUsingWonum method. Error: ',
            error
          );
        },
        complete: () => {},
      });
  }

  openDateSelection(value: string) {
    this.scheduledJobsGetmaximoLink = this.maintScheduleJobsService
      .getScheduledJobsGetmaximoLink(
        value,
        this.facId,
        weeklyScheduleMX.sMxSchApp
      )
      .subscribe({
        next: (data: HttpResponse<string>) => {
          const url = data as unknown as string;
          if (url?.includes('http')) {
            window.open(url, '_blank');
          }
        },
        error: (error) => {
          console.log(
            'Error occured in openDateSelection method. Error: ',
            error
          );
        },
        complete: () => {},
      });
  }

  exportToExcel() {
    this.showExportLoader = true;
    const pad = (n: number) => String(n).padStart(2, '0');
    let date = `${this.wwDate.getFullYear()}-${pad(this.wwDate.getMonth() + 1)}-${pad(this.wwDate.getDate())}`;

    if (this.selectedFilter == 'showall') {
      let data: ExportToExcel = {
        startDate: date,
        crew: this.routerData.crew,
        crewType: this.routerData.crewType,
        divisions: this.routerData.divisions,
        units: this.routerData.units,
        isLaborhrsIncluded: this.routerData.isLaborhrsIncluded,
        isScheduledHrsincluded: this.routerData.isScheduledHrsincluded,
        isCategoryCodeScheduled: this.routerData.isCategoryCodeScheduled,
        isManPowerHoursincluded: this.routerData.isManPowerHoursincluded,
        facId: this.routerData.facId,
      };

      this.exportWeeklySchedule = this.maintScheduleJobsService
        .exportWeeklySchedule(data)
        .subscribe({
          next: (response: any) => {
            const contentType = response.headers.get('content-type');
            const blob = new Blob([response.body], {
              type: contentType,
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'WeeklySchedule.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);
          },
          error: (error) => {
            console.error('Export to Excel failed', error);
            alert('Something went wrong. Please try again.');
          },
          complete: () => {
            this.showExportLoader = false;
          },
        });
    } else {
      this.showLoader = false;
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('frm_RFM_WklySch_MX');

      let exportViewWeeklySchedule: ExportViewWeeklySchedule[] = [];

      this.weeklySchedule.forEach((value: ViewWeeklySchedule) => {
        let data: ExportViewWeeklySchedule = {
          WONUM: value.wonum,
          CREW: value.crew,
          DIVISION: value.division,
          BASECRAFT: value.baseCraft,
          TASK_PRIORITY: value.taskPriority,
          TYPE: value.workType,
          TASK_STATUS: value.taskStatus,
          TITLE: value.taskTitle,
          MON: value.d1 ?? '',
          TUE: value.d2 ?? '',
          WED: value.d3 ?? '',
          THU: value.d4 ?? '',
          hrs_WW_TOT: value.totalHours,
          FRI: value.d5 ?? '',
          SAT: value.d6 ?? '',
          SUN: value.d7 ?? '',
          Hist: value.hist,
          LOCATION: value.location,
          UNIT: value.unit ?? '',
          HRS_WO_EST: value.scheduledHours,
          Matl_Ind: value.sme,
          OT_IND: value.otInd ?? '',
          FINISH_BY: this.formatDates(value.fbd),
          TASK_TYPE: value.taskType,
          HRS_WO_ACT: value.hoursActual,
          MOC_NUMBER: value.mocNumber ?? '',
          DOCNAME: value.docName ?? '',
          MPHC: value.mpQty,
          WORK_TYPE_FULL: value.workTypeLong,
          MOC_REQUIRED: value.mocReqd ?? '',
          JOBDC:
            value.jobDelayCode === null || value.jobDelayCode === '' ? '' : 'Y',
          DelayDescription: value.delayDesc ?? '',
          Criticality: value.criticality ?? '',
          HIST_FLG: value.hist_Flag,
          Week_startdate: new Date(this.wwDate).toLocaleDateString('en-US'),
          MISCOPE: value.miScope,
          LONG_DESCRIPTION: value.taskLongDescription ?? '',
        };
        exportViewWeeklySchedule.push(data);
      });

      const headers = Object.keys(exportViewWeeklySchedule[0]).map(
        (header) => header
      );

      const headerRow = worksheet.addRow(headers);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '156082' },
        };
        cell.alignment = { horizontal: 'left', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        };
      });

      worksheet.autoFilter = {
        from: { row: 1, column: 1 },
        to: {
          row: exportViewWeeklySchedule.length + 1,
          column: Object.keys(exportViewWeeklySchedule[0]).length,
        },
      };

      exportViewWeeklySchedule.forEach((rowData, rowIndex) => {
        const row = worksheet.addRow(
          Object.values(rowData).map((value) =>
            value === '' || value === null ? '' : value
          )
        );

        row.eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: rowIndex % 2 === 0 ? 'C0E6F5' : 'FFFFFF' },
          };

          cell.alignment = { horizontal: 'left', vertical: 'middle' };

          cell.border = {
            top: {
              style: 'thin',
              color: { argb: rowIndex % 2 === 0 ? '87CEFA' : 'A9A9A9' },
            },
            bottom: {
              style: 'thin',
              color: { argb: rowIndex % 2 === 0 ? '87CEFA' : 'A9A9A9' },
            },
            left: {
              style: 'thin',
              color: { argb: rowIndex % 2 === 0 ? '87CEFA' : 'A9A9A9' },
            },
            right: {
              style: 'thin',
              color: { argb: rowIndex % 2 === 0 ? '87CEFA' : 'A9A9A9' },
            },
          };
        });
      });

      const columnWidths = [
        20, 10, 12, 15, 15, 10, 15, 60, 10, 10, 10, 10, 10, 10, 10, 15, 8, 20,
        10, 15, 12, 10, 15, 15, 15, 20, 30, 15, 20, 15, 10, 10, 15, 15, 15, 13,
      ];

      worksheet.columns = columnWidths.map((width) => ({ width }));

      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        FileSaver.saveAs(blob, 'WeeklySchedule.xlsx');
        this.showExportLoader = false;
      });
    }
  }

  round(value: number): number {
    return Math.round(value * 100) / 100;
  }

  ngOnDestroy() {
    if (this.scheduledJobsViewWeeklyScheduleMX) {
      this.scheduledJobsViewWeeklyScheduleMX.unsubscribe();
    }

    if (this.scheduledJobsGetmaximoLink) {
      this.scheduledJobsGetmaximoLink.unsubscribe();
    }

    if (this.exportWeeklySchedule) {
      this.exportWeeklySchedule.unsubscribe();
    }

    this.commonService.setNavigationDisabled(false);
  }
}
